import React from 'react';

const TrustBar = () => {
  return (
    <div className="bg-[#1a3c34] text-white py-4">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-wrap justify-center items-center gap-x-10 gap-y-3 text-sm">
          <div className="flex items-center gap-2">
            <span className="text-xl">✓</span>
            <span>Premium Galfan Coated</span>
          </div>
          <div className="flex items-center gap-2">
            <span>✓</span>
            <span>Nationwide Shipping.</span>
          </div>
          <div className="flex items-center gap-2">
            <span>★</span>
            <span>Trusted by Contractors Across the USA</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustBar;